import { checkElementInView } from '../../../js/src/__utils/checkElementInView';

const animationSelectors = 'section.block-stat-callout:not(.no-animation)';
const sections = document.querySelectorAll(animationSelectors);

const showSection = (e) => {
	e.classList.add('in-viewport');

	e.querySelectorAll('.animated-numbers__number').forEach((el, i) => {
		let duration = 0;
		if (el.dataset.counterNum < 10) {
			duration = el.dataset.counterNum * 300;
		} else {
			duration = 3500;
		}
		animateValue(
			el.querySelectorAll('.counter')[0],
			0,
			el.dataset.counterNum,
			duration
		);
	});
};

const hideSection = (e) => {};

const sectionsInView = () => {
	if (sections.length) {
		checkElementInView(animationSelectors, showSection, hideSection, {
			root: null,
			rootMargin: '0px 0px -20% 0px',
			threshold: [0],
		});
	}
};

const animateValue = (obj, start, end, duration) => {
	let startTimestamp = null;
	const step = (timestamp) => {
		if (!startTimestamp) startTimestamp = timestamp;
		const progress = Math.min((timestamp - startTimestamp) / duration, 1);
		obj.innerHTML = Math.floor(progress * (end - start) + start);
		if (progress < 1) {
			window.requestAnimationFrame(step);
		} else {
			obj.innerHTML = end;
		}
	};
	window.requestAnimationFrame(step);
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {},
	loaded() {
		sectionsInView();
	},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
